import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const featuredCases = [
  {
    company: 'СтройПроект',
    industry: 'Строительство',
    task: 'Поиск подрядчиков в Telegram-чатах',
    result: '142 заявки за месяц',
    conversion: '34% в сделку',
    roi: '×4.8',
  },
  {
    company: 'LegalConsult',
    industry: 'Юридические услуги',
    task: 'Перехват клиентов у конкурентов',
    result: '89 заявок',
    conversion: '41% в сделку',
    roi: '×6.2',
  },
  {
    company: 'MedTech',
    industry: 'Медицинское оборудование',
    task: 'Поиск дистрибьюторов в Telegram',
    result: '56 контактов',
    conversion: '52% в сделку',
    roi: '×7.1',
  },
  {
    company: 'EduPlatform',
    industry: 'Образование',
    task: 'Поиск корпоративных клиентов',
    result: '94 заявки',
    conversion: '44% в сделку',
    roi: '×6.8',
  },
];

export default function CasesSection() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            Кейсы
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 max-w-xl reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Результаты, которые говорят сами за&nbsp;себя
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredCases.map((c, idx) => (
            <div
              key={c.company}
              className={`group/card rounded-2xl border border-background-200 bg-background-50 hover:border-primary-500 transition-all duration-300 p-6 md:p-7 flex flex-col reveal-fade-up ${idx < cardsRevealed ? 'revealed' : ''}`}
              style={idx < cardsRevealed ? { transitionDelay: `${idx * 100}ms` } : undefined}
            >
              <div className="mb-4">
                <h3 className="font-display font-bold text-[15px] text-foreground-950">{c.company}</h3>
                <span className="text-[12px] text-foreground-500 mt-0.5 block">{c.industry}</span>
              </div>

              <p className="text-[13px] text-foreground-600 leading-relaxed mb-4 flex-1">
                {c.task}
              </p>

              <div className="border-t border-background-200 pt-4 grid grid-cols-2 gap-3">
                <div>
                  <span className="text-[11px] text-foreground-400 uppercase tracking-wider">Результат</span>
                  <p className="text-[13px] font-semibold text-foreground-800 mt-0.5">{c.result}</p>
                </div>
                <div>
                  <span className="text-[11px] text-foreground-400 uppercase tracking-wider">Конверсия</span>
                  <p className="text-[13px] font-semibold text-foreground-800 mt-0.5">{c.conversion}</p>
                </div>
                <div className="col-span-2">
                  <span className="text-[11px] text-foreground-400 uppercase tracking-wider">ROI</span>
                  <p className="text-[20px] font-display font-extrabold text-primary-600 mt-0.5">{c.roi}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}